// A video tile that can't play yet (BL-082): how far its upload got, or that it failed its check.
import { videoUploadWords, type VideoUpload } from './gallery-model.ts';

export function VideoWords({ p }: { p: { status: string; upload?: VideoUpload | null } }) {
  const words = videoUploadWords(p, new Date());
  return (
    <>
      ▶ Video
      {words && (
        <>
          <br />
          {words}
        </>
      )}
    </>
  );
}
